package com.sweetlime.dungeonamigo.cache

import kotlin.Long
import kotlin.String

public data class Monsters(
  public val slug: String,
  public val name: String,
  public val size: String?,
  public val type: String?,
  public val alignment: String?,
  public val armor_class: Long?,
  public val hit_points: Long?,
  public val hit_dice: String?,
  public val speed: String?,
  public val challenge_rating: String?,
  public val description: String?,
  public val actions: String?,
)
